import { MainService } from './../Services/service.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';


enum AddWritterView { Loading = 0, FormAndPayment = 1, SendInformationCompleted = 3 }

@Component({
  selector: 'adv-with-us',
  templateUrl: './AdvWithUs.component.html',
  styleUrls: ['./AdvWithUs.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvWithUsComponent implements OnInit {

  public enableAdvertiseWithUs:boolean = false;

  constructor(private mainService: MainService, private router: Router) {
    this.enableAdvertiseWithUs = mainService.enableAdvertiseWithUs;
    if(!this.enableAdvertiseWithUs){
        this.router.navigate(['']);
    }
  }

  ngOnInit() {
    this.mainService.hideLoader(true);
  }
}
